<div [title]="title" class="notification-container" (click)="onNotificationClick()">
  <mat-icon class="notification-icon">{{ icon }}</mat-icon>
    <div *ngIf="notificationCount > 0" class="notification-circle" 
         [style.fontSize]="circleFontSize" 
         [style.backgroundColor]="badgeColor"
         [style.width]="circleWidth" 
         [style.height]="circleHeight" 
         [style.lineHeight]="circleLineHeight">
      {{notificationCount > 99 ? '99+' : notificationCount}}
    </div>
  </div>